// RightPanel.js
import React, { useState, useEffect } from "react";
import ActionsMenu from "../ActionsMenu";
import CollapsibleSection from "./CollapsibleSection";
import Authentication from "../../../api/Authentication/Authentication";
import API from "../../../api/API";
import ThemeToggle from "../../ThemeToggle";

const RightPanel = ({activeTab,selectedItems,selectionMode,currentDirectory,actionMenu,isMobile,handleItemAction,exitSelectionMode}) => {

  const [preview, setPreview] = useState(null)
  const [detailsSectionToggle, setDetailsSectionToggle] = useState(true);
  const [previewSectionToggle, setPreviewSectionToggle] = useState(true);
  const [actionsSectionToggle, setActionsSectionToggle] = useState(true);
  const [allUsers, setAllUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const currentUser = Authentication.getCurrentUser();
        const res = await API.getAllEnabledUsers(currentUser._id, currentUser.token);
        if (res.data.success) {
          setAllUsers(res.data.data);
        }
      } catch (err) {
        console.error("Failed to fetch users:", err);
      }
    };
  
    fetchUsers();
  }, []);
  
  const getUsernameById = (id) => {
    const user = allUsers.find((u) => u._id === id);
    return user ? user.username : id;
  };

  /** Formats bytes into KB, MB, GB, etc. **/
  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
  };

  const truncateFileName = (name, maxLength = 32) => {
    if (name.length <= maxLength) return name;
    return name.slice(0, maxLength - 3) + '...';
  };

  const isImageFile = (fileName) => {
    const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
    const ext = fileName.substring(fileName.lastIndexOf(".")).toLowerCase();
    return imageExtensions.includes(ext);
  };

  useEffect(() => {
    async function getPreview() {
      if (selectedItems.length === 1) {
        const item = selectedItems[0];
        if (item.type === "file" && 
            isImageFile(item.name) && 
            Authentication.getCurrentUser() ) {
          
          try {
            const result = await API.previewFile(
              Authentication.getCurrentUser()?._id, 
              Authentication.getCurrentUser()?.token,
              item.id
            );

            const view = (
              <div className="mt-4">
                <img
                  src={result.request.responseURL}
                  alt={item.name}
                  className="max-w-full h-auto rounded shadow"
                />
              </div>
            );
      
            setPreview(view);
          } catch {
            setPreview(null);
          }
        } else {
          setPreview(null);
        }
      }
    }
    getPreview();
  }, [currentDirectory, selectedItems]);

  return (
    <div className={`bg-gray-50 dark:bg-gray-800 shadow-lg overflow-y-auto ${isMobile ? 'w-full px-2 h-full' : 'w-1/4 rounded-lg p-2 ml-2'}`}>  
      {/* Details section */}     
      <CollapsibleSection title="Details" defaultOpen={detailsSectionToggle} onToggle={setDetailsSectionToggle}>
        {selectedItems && selectedItems.length === 1 ? (
          <>
            <p className="text-gray-600 dark:text-gray-200">
              <strong>Name:</strong> {truncateFileName(selectedItems[0].name)}
            </p>
            <p className="text-gray-600 dark:text-gray-200">
              <strong>Type:</strong> {selectedItems[0].type === "dir" ? "Folder" : "File"}
            </p>
            {selectedItems[0].type === "file" && (
              <p className="text-gray-600 dark:text-gray-200">
                <strong>Size:</strong> {formatFileSize(selectedItems[0].size)}
              </p>
            )}
              {/* 🔐 Sharing Info */}
            {activeTab !== 'shared' && (<div className="mt-4">
              <p className="text-gray-600 dark:text-gray-200">
                <strong>Shared:</strong>{" "}
                {selectedItems[0].sharedWith && selectedItems[0].sharedWith.length > 0
                  ? `Yes (${selectedItems[0].sharedWith.length} user${selectedItems[0].sharedWith.length > 1 ? 's' : ''})`
                  : "No"}
              </p>

              {selectedItems[0].sharedWith && selectedItems[0].sharedWith.length > 0 && (
                <div className="mt-2">
                  <p className="text-gray-600 dark:text-gray-200 font-semibold">Shared With:</p>
                  <ul className="list-disc list-inside text-gray-600 dark:text-gray-200 text-sm">
                    {selectedItems[0].sharedWith.map((id) => (
                      <li key={id}>{getUsernameById(id)}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>)}
          </>
        ) : (
          <p className="text-gray-500 dark:text-gray-400">Select a file or folder to see details.</p>         
        )}
      </CollapsibleSection>
      
      {/* File Preview Section */}         
      {selectedItems && selectedItems.length === 1 && isImageFile(selectedItems[0].name) ?
        <CollapsibleSection title="Preview" defaultOpen={previewSectionToggle} onToggle={setPreviewSectionToggle}>
          {preview}
        </CollapsibleSection>
      :
        <></>
      }
      
      {/* Actions Section */}
      <CollapsibleSection title="Actions" defaultOpen={actionsSectionToggle} onToggle={setActionsSectionToggle}>
        <ActionsMenu
          selectedItems={selectedItems}
          selectionMode={selectionMode}
          actionMenu={actionMenu}
          handleAction={handleItemAction}
          exitSelectionMode={exitSelectionMode}
          activeTab={activeTab}
        />
      </CollapsibleSection>
      
      
      <div className="bg-white dark:bg-gray-800">
        <hr className="h-px my-4 bg-gray-200 border-0 dark:bg-gray-700"/>
      </div>

      {/* Theme Select */}
      {!isMobile && (
        <div className="flex items-center justify-between bg-gray-50 dark:bg-gray-800 bg-gray-200 p-2">
          <p className="text-gray-600 dark:text-gray-200 pr-2">Theme</p>
          <ThemeToggle/>
        </div>
      )}

    </div>
  );
};

export default RightPanel;